import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./App.scss";
import Notifier from "./containers/Notifier/notifier";
import queryString from "query-string";

import history from "./utils/history";
import { saveUrlFrom, setAuthentication } from "./store/actions";

import Cookies from "js-cookie";
import SSOLoginCallback from "./containers/SSO/SSOLoginCallback";
import SSOLogin from "./containers/SSO/SSOLogin";
import SSORegister from "./containers/SSO/SSORegister";

const App = () => {
    const state = useSelector((state) => state.general);
    const dispatch = useDispatch();
    const [redirect, redirectSet] = useState(null);

    useEffect(() => {
        dispatch(setAuthentication());
        const parsed = queryString.parse(history.location.search);
        if (parsed.s) {
            redirectSet(parsed.s);
        } else {
            redirectSet(sessionStorage.getItem("source"));
        }
    }, []);

    useEffect(() => {
        if (redirect) {
            dispatch(saveUrlFrom(redirect));
        } else {
            dispatch(saveUrlFrom("platform"));
        }
    }, [state.redirect]);

    // -------------- CODE TO DEPRECATE AFTER CAVSMS PROJECT END -------------------

    // We have provided registration links with activation codes for
    // different roles and sites in the CAVSMS project,
    // of the form https://client.qmenta.com/#/register?c=123456789
    // which now re-directs to https://me.qmenta.com/?s=platform#/register?c=123456789
    // which does not work for registration. The code below will update
    // the URL to be compatible.

    const parsedCavsMsActivationCode = queryString.parse(history.location.hash);

    useEffect(() => {
        if (parsedCavsMsActivationCode["/register?c"]) {
            window.location.replace(`${window.location.origin}${window.location.pathname}register?c=${parsedCavsMsActivationCode["/register?c"]}`);
        }
    });

    // -------------- END OF THE CODE TO DEPRECATE -------------------

    return (
        //eslint-disable-next-line no-undef
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Notifier />
            <Switch>
                {Cookies.get("AUTH_COOKIE") ?
                    <Route path="/auth/login" component={SSOLogin} /> :
                    <Redirect from="/auth/login" to={"/"} />
                }
                <Redirect from="/change_password" to={"/"} />
                <Route exact path="/register" component={SSORegister} />
                <Route exact path="/" component={SSOLogin} />
                <Route exact path="/auth/callback" component={SSOLoginCallback} />
            </Switch>
        </BrowserRouter>
    );
};

export default App;